import { getClientLocation } from "@/lib/location";
import { getCurrencyForLocation } from "@/lib/currency";
import AppShell from "./AppShell";

export default async function AppLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = await getClientLocation();
  const currency = getCurrencyForLocation(location);

  return (
    <AppShell
      initialPage="home"
      initialChildren={children}
      currency={currency}
    />
  );
}
